// removed by extract-text-webpack-plugin
module.exports = {"heroImage":"index-module__heroImage___2-qoy","rightItems":"index-module__rightItems___2b1rs"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/contact-us/index.module.scss
// module id = 1886
// module chunks = 146